import useTranslation from "@/hooks/useTranslation";
import { NaviParams } from "@/interfaces/navi.interface";
import { DatePicker } from "antd";
import moment from "moment";
import React, { useMemo } from "react";
import styles from "./styles.module.less";

const { wrapper, flex, label } = styles;

const { RangePicker } = DatePicker;

interface IProps {
  mindate: string;
  maxdate: string;
  setSearchParams: (searchParams: Partial<NaviParams>) => void;
}

const DateFilter: React.FC<IProps> = ({
  mindate,
  maxdate,
  setSearchParams,
}) => {
  const { t } = useTranslation("explore");

  const onChange = (dates: [moment.Moment, moment.Moment]) => {
    if (!dates) {
      setSearchParams({ mindate: undefined, maxdate: undefined });
    }
    if (dates?.length > 0) {
      setSearchParams({
        mindate: dates[0].format("YYYY/MM/DD"),
        maxdate: dates[1].format("YYYY/MM/DD"),
      });
    }
  };

  const defaultDate = useMemo(
    () => [
      mindate ? moment(mindate, "YYYY/MM/DD") : undefined,
      maxdate ? moment(maxdate, "YYYY/MM/DD") : undefined,
    ],
    [mindate, maxdate]
  );

  return (
    <div className={wrapper}>
      <div className={flex}>
        <div className={label}>{t("pubmed.sidebar.publication-date")}</div>
      </div>
      <RangePicker
        // @ts-ignore
        value={defaultDate}
        format="YY/MM/DD"
        // @ts-ignore
        onChange={onChange}
        ranges={{
          "This Year": [moment().startOf("year"), moment()],
          "Last 3 years": [
            moment().startOf("year").subtract(3, "years"),
            moment(),
          ],
          "Last 5 years": [
            moment().startOf("year").subtract(5, "years"),
            moment(),
          ],
        }}
      />
    </div>
  );
};

export default DateFilter;
